/**
 * @fileoverview
 * Constants and helpers used by the Grid component.
 */
import { WidgetSizeEnum } from '@core/types';
export var ScrollDirectionEnum;
(function (ScrollDirectionEnum) {
    ScrollDirectionEnum["LEFT"] = "scroll-left";
    ScrollDirectionEnum["RIGHT"] = "scroll-right";
})(ScrollDirectionEnum || (ScrollDirectionEnum = {}));
export const RESPONSIVE_THUMBNAIL_WIDTHS = {
    [WidgetSizeEnum.SMALL]: {
        minThumbWidth: 255,
        maxThumbWidth: 255,
        maxColumns: 5,
    },
    [WidgetSizeEnum.MEDIUM]: {
        minThumbWidth: 255,
        maxThumbWidth: 275,
        maxColumns: 5,
    },
    [WidgetSizeEnum.LARGE]: {
        minThumbWidth: 255,
        maxThumbWidth: 300,
        maxColumns: 4,
    },
};
export const DEFAULT_THUMBNAIL_GAP_PX = 10;
/**
 *
 * number of responsive columns is the number of max width thumbs
 * that can fit in the carousel viewport width, rounding up.
 * This lets the thumbnails shrink for a bit before breaking down to
 * the next column.
 *
 * We subtract one gap from the width because gaps
 * are between columns so there's one less gap than columns
 *
 * @param viewportWidth
 * @returns
 */
export function responsiveColumnsForWidth({ viewportWidth, maxThumbWidth, gap, maxColumns, }) {
    const curVisibleCols = Math.ceil((viewportWidth - gap) / (maxThumbWidth + gap));
    return Math.min(maxColumns, curVisibleCols);
}
/**
 * Calculate the number of columns for a given width
 * for a embed-feed's "grid" mode.
 */
export const columnsForWidth = (width) => {
    if (width >= 960) {
        return 5;
    }
    else if (width >= 640) {
        return 4;
    }
    else if (width >= 480) {
        return 3;
    }
    return 2;
};
const SM_MIN_NEW_CARD_WIDTH_BELOW_1024 = 346;
const SM_MIN_NEW_CARD_WIDTH_ABOVE_1024 = 346;
const MD_MIN_NEW_CARD_WIDTH_BELOW_1024 = 338;
const MD_MIN_NEW_CARD_WIDTH_ABOVE_1024 = 350;
const LG_MIN_NEW_CARD_WIDTH_BELOW_1024 = 480;
const LG_MIN_NEW_CARD_WIDTH_ABOVE_1024 = 492;
const getDynamicCarouselMinWidths = (size) => {
    switch (size) {
        case WidgetSizeEnum.MEDIUM:
            return {
                minWidthBelow1024: MD_MIN_NEW_CARD_WIDTH_BELOW_1024,
                minWidthAbove1024: MD_MIN_NEW_CARD_WIDTH_ABOVE_1024,
            };
        case WidgetSizeEnum.SMALL:
            return {
                minWidthBelow1024: SM_MIN_NEW_CARD_WIDTH_BELOW_1024,
                minWidthAbove1024: SM_MIN_NEW_CARD_WIDTH_ABOVE_1024,
            };
        default:
            return {
                minWidthBelow1024: LG_MIN_NEW_CARD_WIDTH_BELOW_1024,
                minWidthAbove1024: LG_MIN_NEW_CARD_WIDTH_ABOVE_1024,
            };
    }
};
/**
 * [CS-6201] Calculate number of columns based on number of videos for medium carousel V2
 * and decide if we're showing the new card style or not
 */
export const columnsByVideoCount = ({ count, containerWidth, size, }) => {
    const { minWidthAbove1024, minWidthBelow1024 } = getDynamicCarouselMinWidths(size);
    const cardWidth = containerWidth < 1024 ? minWidthBelow1024 : minWidthAbove1024;
    // only show if the container is wide enough to show all cards
    const showV2Card = (containerWidth - (count - 1) * 10) / count >= cardWidth;
    const columns = showV2Card ? count : columnsForWidth(containerWidth);
    return { columns, showV2Card };
};
